
const ACTIVE_THEME = null;

const _registry = [

  {
    id: 'liberation-day',
    name: 'Ngày Giải Phóng Miền Nam 30/4',
    priority: 88,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return (m === 4 && d >= 26) || (m === 5 && d <= 2);
    },

    bgClass: 'liberation-day-bg',

    headerBg:      '#4a0000',
    headerColor:   '#FFFFFF',
    subtitleColor: '#FFE066',

    tableHeaderBg: '#6B0000',
    tableShiftBg:  '#8B0000',
    tableBorder:   '#DA251D',

    colRoomBg:    '#fff8e1',
    rowOddBg:     '#ffffff',
    headerWrapBg: 'rgba(74, 0, 0, 0.97)',
    scrollBg:     'rgba(74, 0, 0, 0.92)',

    footerBg:    '#4a0000',
    footerColor: '#FFCC00',

    title:           'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:        'Kỷ Niệm 51 Năm Ngày Giải Phóng Miền Nam Thống Nhất Đất Nước (30/4/1975 – 30/4/2026)',
    footerText:      'Bệnh Viện Hùng Vương Gia Lai kính chào mừng 51 năm Ngày Giải Phóng Miền Nam Thống Nhất Đất Nước',
    footerCopyright: '© 2026 Hệ Thống Y Tế Hùng Vương - Phòng CNTT™ - leanhquan™',

    decoration: 'liberation-day',
  },

  {
    id: 'national-day',
    name: 'Ngày Quốc Khánh 2/9',
    priority: 89,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      // Bắt đầu 00:00 ngày 25/8, kết thúc 06:00 sáng ngày 3/9
      if (m === 8) return d >= 25;
      if (m === 9) return d < 3 || (d === 3 && h < 6);
      return false;
    },

    bgClass: 'national-day-bg',

    headerBg:      '#7a0000',
    headerColor:   '#FFFFFF',
    subtitleColor: '#FFE066',

    tableHeaderBg: '#8B0000',
    tableShiftBg:  '#A30000',
    tableBorder:   '#DA251D',

    colRoomBg:    '#fff8e1',
    rowOddBg:     '#ffffff',
    headerWrapBg: 'rgba(122, 0, 0, 0.97)',
    scrollBg:     'rgba(122, 0, 0, 0.92)',

    footerBg:    '#7a0000',
    footerColor: '#FFCC00',

    title:           'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:        'Chào Mừng 81 Năm Quốc Khánh Nước CHXHCN Việt Nam (2/9/1945 – 2/9/2026)',
    footerText:      'Bệnh Viện Hùng Vương Gia Lai kính chào mừng 81 năm Ngày Quốc Khánh Nước Cộng Hòa Xã Hội Chủ Nghĩa Việt Nam',
    footerCopyright: '© 2026 Hệ Thống Y Tế Hùng Vương - Phòng CNTT™ - leanhquan™',

    decoration: 'national-day',
  },

  {
    id: 'patient-safety-day',
    name: 'Ngày An Toàn Người Bệnh Thế Giới 17/9',
    priority: 95,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      // Chạy từ 9/9 đến hết ngày 17/9
      return m === 9 && d >= 9 && d <= 17;
    },

    bgClass: 'patient-safety-day-bg',

    headerBg:      'linear-gradient(135deg, #C85A00 0%, #FF7A00 55%, #FF9A3D 100%)',
    headerColor:   '#FFFFFF',
    subtitleColor: '#FFF3E0',

    tableHeaderBg: '#E06A00',
    tableShiftBg:  'linear-gradient(135deg, #E06A00 0%, #FF9A3D 100%)',
    tableBorder:   '#FFB066',

    colRoomBg:    'linear-gradient(160deg, #fffaf3 0%, #ffe8cc 100%)',
    rowOddBg:     '#fff6ea',
    headerWrapBg: 'rgba(230, 106, 0, 0.97)',
    scrollBg:     'rgba(255, 250, 243, 0.95)',

    footerBg:    '#C85A00',
    footerColor: '#FFFFFF',

    title:           'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:        'Hưởng Ứng Ngày An Toàn Người Bệnh Thế Giới 17/9 – "Chăm Sóc An Toàn Cho Cuộc Sống!"',
    footerText:      'Bệnh Viện Hùng Vương Gia Lai hưởng ứng Ngày An Toàn Người Bệnh Thế Giới 17/9 — Chăm sóc an toàn cho các bệnh không lây nhiễm',
    footerCopyright: '© 2026 Hệ Thống Y Tế Hùng Vương - Phòng CNTT™ - leanhquan™',

    decoration: 'patient-safety-day',
  },

 {
    id: 'women-day',
    name: 'Ngày Quốc Tế Phụ Nữ 8/3',
    priority: 90,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return m === 3 && d >= 3 && d <= 8;
    },

    bgClass: 'women-day-bg',

    headerBg:      '#f4d5da',
    headerColor:   '#8b1a2f',
    subtitleColor: '#a0273a',

    tableHeaderBg: '#f4d5da',
    tableShiftBg:  '#ebbfc8',
    tableBorder:   '#d4889a',

    colRoomBg:    'linear-gradient(160deg, #ffffff 0%, #fff0f3 100%)',
    rowOddBg:     '#fff5f7',
    headerWrapBg: 'rgba(255, 255, 255, 0.98)',
    scrollBg:     'rgba(255, 255, 255, 0.97)',

    footerBg:    '#f4d5da',
    footerColor: '#8b1a2f',

    title:      'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:   'Chúc Mừng Ngày Quốc Tế Phụ Nữ 8/3',
    footerText: 'Bệnh Viện Hùng Vương Gia Lai kính chúc Ngày Quốc Tế Phụ Nữ 8/3 hạnh phúc, yêu thương  🌸',

    decoration: 'women-day',
  },

  {
    id: 'doctor-day',
    name: 'Ngày Thầy Thuốc Việt Nam 27/02',
    priority: 100,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return m === 2 && d >= 24 && d <= 28;
    },

    bgClass: 'doctor-day-bg',

    headerBg:     'linear-gradient(135deg, #0c6a9e 0%, #1e90c0 60%, #2CA8E0 100%)',
    subtitleColor: '#e8f8ff',

    tableHeaderBg: '#0c6a9e',
    tableShiftBg:  'linear-gradient(135deg, #0e7ab5 0%, #2CA8E0 100%)',
    tableBorder:   '#93d4f0',

    colRoomBg:    'linear-gradient(160deg, #f4fbff 0%, #d6eef9 100%)',
    rowOddBg:     '#eef7fd',
    headerWrapBg: 'rgba(240, 251, 255, 0.98)',
    scrollBg:     'rgba(244, 251, 255, 0.97)',

    footerBg:    '#0c6a9e',
    footerColor: '#ffffff',

    title:      'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:   '✦ Chào Mừng Ngày Thầy Thuốc Việt Nam 27/02 ✦',
    footerText: 'Bệnh Viện Hùng Vương Gia Lai trân trọng tri ân những người thầy thuốc tận tâm  ❤',

    decoration: 'doctor-day',
  },

  {
    id: 'tet',
    name: 'Tết Nguyên Đán 2026',
    priority: 50,
    isActive: (date) => {
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return (
        (m === 1 && d >= 20) ||
        (m === 2 && d <= 23) ||
        (m === 3 && d <= 5)
      );
    },

    bgClass: 'tet-bg',

    headerBg:     'linear-gradient(#b91c1c, #b91c1c)',
    subtitleColor: '#fffbeb',

    tableHeaderBg: '#b91c1c',
    tableShiftBg:  'linear-gradient(135deg, #b91c1c 0%, #f97416 100%)',
    tableBorder:   '#7f1d1d',
    colRoomBg:     'linear-gradient(135deg, #fef3c7 0%, #fecaca 100%)',
    rowOddBg:      '#fdefe1',

    headerWrapBg: 'rgba(255, 250, 240, 0.96)',
    scrollBg:     'rgba(255, 250, 240, 0.90)',

    footerBg:    '#b91c1c',
    footerColor: '#f5dd88',

    title:      'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:   'Bệnh Viện Hùng Vương Gia Lai – Chúc Mừng Năm Mới 2026 🎉',
    footerText: 'Bệnh Viện Hùng Vương Gia Lai kính chúc Năm Mới An Khang – Thịnh Vượng',

    decoration: 'tet',
  },

  {
    id: 'default',
    name: 'Mặc định',
    priority: 0,
    isActive: () => true,

    bgClass: 'default-bg',

    headerBg:      'linear-gradient(135deg, #2ca8e0 0%, #3fbde9 100%)',
    subtitleColor: '#d6f0fb',

    tableHeaderBg: '#2ca8e0',
    tableShiftBg:  'linear-gradient(90deg, #2ca8e0 0%, #3fbde9 100%)',
    tableBorder:   '#9dd8ef',
    colRoomBg:     'linear-gradient(160deg, #ffffff 0%, #e4f5fb 100%)',
    rowOddBg:      '#e4f5fb',

    headerWrapBg: 'rgba(244, 250, 253, 0.97)',
    scrollBg:     'rgba(244, 250, 253, 0.95)',

    footerBg:    'linear-gradient(90deg, #2ca8e0 0%, #3fbde9 100%)',
    footerColor: '#ffffff',

    title:           'LỊCH LÀM VIỆC PHÒNG KHÁM',
    subtitle:        'Bệnh Viện Hùng Vương Gia Lai',
    footerText:      'Bệnh Viện Hùng Vương Gia Lai',
    footerCopyright: '© 2026 Phòng Công Nghệ Thông Tin™ - leanhquan™',

    decoration: 'none',
  },
];

class ThemeConfig {
  static getActive(date = new Date()) {
    if (ACTIVE_THEME) {
      return _registry.find((t) => t.id === ACTIVE_THEME)
        ?? _registry.find((t) => t.id === 'default');
    }
    const candidates = _registry
      .filter((t) => t.isActive(date))
      .sort((a, b) => b.priority - a.priority);
    return candidates[0] ?? _registry.find((t) => t.id === 'default');
  }

  static getById(id) {
    return _registry.find((t) => t.id === id) ?? null;
  }

  /**
   * Đăng ký theme mới.
   * Nếu id đã tồn tại → ghi đè; chưa tồn tại → thêm mới.
   * @param {object} theme
   */
  static register(theme) {
    const idx = _registry.findIndex((t) => t.id === theme.id);
    if (idx >= 0) _registry[idx] = theme;
    else _registry.push(theme);
  }

  static getAll() {
    return [..._registry];
  }
}

export default ThemeConfig;
